import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  Wallet, 
  Factory, 
  Blocks, 
  Pickaxe, 
  FileText, 
  Coins,
  Code 
} from 'lucide-react';

const Sidebar = () => {
  const location = useLocation();
  
  const links = [
    { path: '/', icon: Home, label: 'Dashboard' },
    { path: '/wallet', icon: Wallet, label: 'Wallet' },
    { path: '/token-factory', icon: Factory, label: 'Token Factory' },
    { path: '/explorer', icon: Blocks, label: 'Explorer' },
    { path: '/mining', icon: Pickaxe, label: 'Mining' },
    { path: '/tokens', icon: Coins, label: 'Tokens' },
    { path: '/developer/login', icon: Code, label: 'Developer Portal' },
    { path: '/whitepaper', icon: FileText, label: 'Whitepaper' },
  ];
  
  return (
    <div className="w-64 h-screen bg-background-card border-r border-border fixed left-0 top-0 flex flex-col">
      <div className="p-6 border-b border-border">
        <h1 className="font-unbounded text-2xl font-bold tracking-tight">
          <span className="text-primary">Block</span>
          <span className="text-text-primary">Chain</span>
        </h1>
        <p className="text-text-muted text-xs mt-1 font-mono">v2.0.0 • Testnet</p>
      </div>
      
      <nav className="flex-1 p-4">
        {links.map((link) => {
          const Icon = link.icon;
          const isActive = location.pathname === link.path;
          
          return (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
              className={`
                flex items-center gap-3 px-4 py-3 rounded-sm mb-2
                transition-colors duration-200
                ${
                  isActive
                    ? 'bg-primary/10 text-primary border border-primary/30'
                    : 'text-text-secondary hover:text-primary hover:bg-background-subtle'
                }
              `}
            >
              <Icon size={20} strokeWidth={1.5} />
              <span className="font-medium">{link.label}</span>
            </Link>
          );
        })}
      </nav>
      
      <div className="p-4 border-t border-border">
        <div className="glass p-4 rounded-sm">
          <p className="text-xs text-text-muted mb-1">Network Status</p>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 bg-accent-success rounded-full animate-pulse" />
            <span className="text-sm text-text-primary font-medium">Online</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
